import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx'
import { Link } from 'react-router-dom'
import TwoStepConfirmationButton from "../components/TwoStepConfirmButton.js"
import ActionResult from '../components/ActionResult.js'

function DiscretionaryAlerts(props) {
    const [data, setData] = useState([]);
    const [result, setResult] = useState(null)
    const [updates, setUpdates] = useState(0);

    useEffect(() => {
        (async function () {

            setData([]);
            let text = await (await fetch(`/api/discretionaryStategyAlerts`)).json();
            if (text && Array.isArray(text)) {
                text.sort((a, b) => a.symbol < b.symbol ? -1 : 1)
            }
            setData(text);
        })();
    }, [updates, props.planId]);

    function getAlerts() {

        const alerts = data;

        return alerts.map(alert => {
            return {
                id: alert.idtrading_strategy_alerts,
                strategyId: alert.strategyId,
                strategyName: alert.name,
                algoName: alert.algo_name,
                symbol: alert.symbol,
                timeframe: alert.timeframe,
                config: alert.config,
                create_date: alert.create_date,
                paused: alert.paused,
                status: alert.paused ? "Paused" : "Active",
                last_triggered: alert.last_triggered,
                pendingConfig: alert.pending_config
            }
        });
    }

    function shouldAllowEdits() {
        if (props.role === 3) return true;
        else return false;
    }

    async function handleTriggerAlert(alertId) {
        console.log("handleTriggerAlert", alertId);
        const url = "/api/strategyAlertDiscretionaryTrigger?alertId=" + alertId;
        const r = await (await fetch(url, { method: 'POST' })).json();
        setResult(r);
        setUpdates(updates + 1);
    }

    function adminButtonsFormatter(cell, row) {
        return (
            <>
                {shouldAllowEdits() && !row.last_triggered ? <TwoStepConfirmationButton id={row.id} text="Trigger Entry" onConfirmed={handleTriggerAlert} /> : null}
                {shouldAllowEdits() && row.last_triggered ? <TwoStepConfirmationButton id={row.id} text="Trigger Exit" onConfirmed={handleTriggerAlert} /> : null}
            </>
        )
    }

    function configureButtonFormatter(cell, row) {
        return (
            <>
                <Link className="bg-transparent" to={"/configureAlert/" + row.id}>Update</Link >
            </>
        )
    }

    return (
        <>
            <RichTable data={getAlerts()} className="table-striped table-hover table-condensed" mappers={[
                { title: 'Algo Name', field: 'algoName', filter: 'text' },
                { title: 'Symbol', field: 'symbol', sorters: true, filter: 'text' },
                { title: 'Strategy', field: 'strategyName', sorters: true, filter: 'text', hidden: props.mobileView },
                { title: 'Configure', field: 'id', formatter: configureButtonFormatter },
                { title: 'Triggered', field: 'last_triggered', sorters: true },
                { title: 'Manage', field: 'id', formatter: adminButtonsFormatter, sorters: true, hidden: !shouldAllowEdits() || props.mobileView }
            ]} />

            <ActionResult result={result} />
        </>
    );
}

export default DiscretionaryAlerts;